export interface EnvironmentConfig {
  enableAngularProdMode: boolean;
  enableOnboarding: boolean;
  apiUrl: string;
  env: 'local' | 'development' | 'staging' | 'production';
  universalAppUrl: string;
  urlScheme: string;
  auth: {
    refreshTokenBeforeExpirationMinutes: number;
  };
  cache: {
    /** Cache default duration in minutes */
    defaultMinutes: number;
  };
  googleTagManager: {
    id: string;
    auth: string;
    preview: string;
    isActive: boolean;
    gaTrackingId: string;
  };

  appInsights: {
    instrumentationKey: string;
    trackPageView: boolean;
  };

  logging: {
    [loggerName: string]: LoggerConfig;
  };
}

export interface LoggerConfig {
  logLevel: LogLevel;
  isActive: boolean;
}

export enum LogLevel {
  Fatal = 'Fatal',
  Error = 'Error',
  Warn = 'Warn',
  Info = 'Info',
  Debug = 'Debug',
}
